// JavaScript Document
jQuery( document ).ready(function($) {
    
	$(document).foundation();

	$('.hamburger').on('click', function(){
		
		$('.hamburger').toggleClass('is-active');
		$('.overlay-menu').toggleClass('is-active'); 
		$('html').toggleClass('locked');

	});
	
	//ACCORDION MOBILE MENU
	$('.is-accordion-submenu-parent a').click(function(){
        $(this).unbind('click');
	});
	
	$(window).scroll(function() {
		if ($(this).scrollTop() > 50)
		{
		 $('.site-header').addClass("sticky");
		}
		else
		{
		 $('.site-header').removeClass("sticky");
		}
   });
	// Customizing a reveal set
	window.sr = ScrollReveal();
	
	sr.reveal('.rvl', {
		duration: 500,
		distance:'0px',
		scale:1,
		delay:100
		});
	
	sr.reveal('.str', { 
		duration: 500,
		origin: 'bottom',
		scale: 1
	}, 70);

	//GET POPUP
	function showVergelijkPopup(){
		
		$.ajax({
			url: '/wp-content/themes/donkeycomm/assets/vergelijk/get-list.php',
			type: 'get',
			success: function(response) {
				console.log(response);
			},
			error: function(response){
				console.log(response);
				
			}
		});
	
	}
	//VERGELIJK POPUP
	$('#vergelijk-popup .close-popup').on('click', function(){
		$('#vergelijk-popup').toggleClass('active');
	});
	$('#vergelijk-popup .remove-item').on('click', function(){
		 //REMOVE FROM LIST
		 
			$(this).addClass('disabled');
			var data = {};
			data.id = $(this).data('id');
			
			$.ajax({
				url: '/wp-content/themes/donkeycomm/assets/vergelijk/remove-from-list.php',
				type: 'post',
				data: data,
				success: function(response) {
				   
					if(response == 'success'){
						$('.item[data-id="'+data.id+'"]').remove();
						if($('#vergelijk-popup .item').length < 1){
							$('.button1.vergelijk').hide();
							$('#vergelijk-popup .empty-message').show();
						} else {
							$('.button1.vergelijk').show();
							$('#vergelijk-popup .empty-message').hide();
						}
					} else {
						alert('Mislukt, probeer nogmaals.');
						$(this).removeClass('disabled');
					}
				
				},
				error: function(response){
					
					$(this).removeClass('disabled');
					
					
				}
			});
	});
});
